const ptBR = {
  metaTitle: 'WSJ Pedidos | WSJ Soluções Digitais',
  badge: 'Produto WSJ',
  heroTitle: 'Venda, agende e organize seus pedidos em uma única plataforma',
  heroSubtitle:
    'Um sistema completo para negócios locais que precisam receber pedidos, controlar horários, vender pelo WhatsApp e atender melhor seus clientes.',
  heroTrust: 'Cardápio digital · Agenda inteligente · Painel do lojista · WhatsApp integrado',
  btnDemo: 'Ver demonstração',
  btnAdmin: 'Acessar painel',
  btnWhatsapp: 'Falar no WhatsApp',
  btnWant: 'Quero o WSJ Pedidos',
  btnDemoMenu: 'Ver cardápio demo',
  btnDemoAdmin: 'Acessar painel demo',
  btnTalkWsj: 'Falar com a WSJ',
  midCtaTitle: 'Menos conversa solta. Mais pedidos fechados.',
  midCtaSubtitle: 'Um fluxo profissional do cardápio ao WhatsApp — seu cliente sabe o que pode escolher e quando.',
  sectionBusiness: 'Feito para o seu tipo de negócio',
  sectionBusinessLead: 'O mesmo núcleo poderoso, com a cara do seu atendimento.',
  businessTypes: [
    { title: 'Barbearias', desc: 'Serviços com tempo, fila e pacotes sob controle.' },
    { title: 'Salões de beleza', desc: 'Agenda por profissional e comissão de horários clara.' },
    { title: 'Manicure e unhas', desc: 'Slots curtos, lista de serviços e upsell no cardápio.' },
    { title: 'Estética', desc: 'Tratamentos com duração e recuperação de agenda automática.' },
    { title: 'Confeitarias e bolos', desc: 'Encomendas com data, sabor e observações sem erro.' },
    { title: 'Salgados sob encomenda', desc: 'Produção por lote com retirada e capacidade por dia.' },
    { title: 'Restaurantes e delivery', desc: 'Pedidos organizados com entrega ou balcão.' },
    { title: 'Personal trainer / por hora', desc: 'Capacidade por horário e bloqueio do que já foi vendido.' }
  ],
  sectionControl: 'Controle total dos pedidos',
  sectionControlLead: 'Tudo o que o cliente vê e o que você gerencia — conectado em tempo real.',
  controlFeatures: [
    { title: 'Cardápio digital', desc: 'Catálogo bonito no celular, com fotos, preços e complementos.' },
    { title: 'Pedidos pelo WhatsApp', desc: 'Resumo objetivo do pedido ou agendamento direto no app.' },
    { title: 'Painel do lojista', desc: 'Pedidos, agenda e catálogo em um painel pensado para o dia a dia.' },
    { title: 'Entrega e retirada', desc: 'Modalidades claras para o cliente e fáceis de operar.' },
    { title: 'Produtos sob encomenda', desc: 'Prazo, observações e status para doces e salgados.' },
    { title: 'Serviços com horário marcado', desc: 'Reserva com duração e profissional certo.' },
    { title: 'Controle de capacidade', desc: 'Limite por horário para não prometer o que não dá.' },
    { title: 'Bloqueio de horários ocupados', desc: 'Evita choque de horários e mensagens duplicadas.' }
  ],
  sectionCompare: 'Do caos ao controle',
  sectionCompareLead: 'O WhatsApp continua no centro — mas com processo profissional em volta.',
  beforeTitle: 'Antes',
  afterTitle: 'Depois, com WSJ Pedidos',
  beforeItems: [
    'Pedidos perdidos no meio do WhatsApp',
    'Horários duplicados ou esquecidos',
    'Cliente perguntando disponibilidade o tempo todo',
    'Falta de padrão na coleta de informações',
    'Erros em encomendas e sabores'
  ],
  afterItems: [
    'Cliente escolhe data e horário com clareza',
    'Agenda bloqueia horários ocupados automaticamente',
    'Lojista gerencia tudo no painel',
    'Pedido chega organizado no WhatsApp',
    'Menos erro, mais profissionalismo e reputação'
  ],
  sectionAgenda: 'Agenda inteligente',
  sectionAgendaLead: 'Regras de negócio que acompanham a rotina real — não uma planilha estática.',
  agendaPoints: [
    { title: 'Horários por dia da semana', desc: 'Aberturas diferentes para segunda, sábado ou feriado.' },
    { title: 'Datas especiais', desc: 'Bloqueios ou janelas extras quando precisar.' },
    { title: 'Capacidade por horário', desc: 'Limite de pedidos ou atendimentos por faixa.' },
    { title: 'Serviços com duração', desc: 'O slot respeita o tempo do serviço automaticamente.' },
    { title: 'Bloqueio automático', desc: 'Horário ocupado some para o cliente — sem overbooking.' }
  ],
  sectionHow: 'Como funciona',
  sectionHowLead: 'Em poucos passos você coloca a operação no piloto automático.',
  howSteps: [
    { title: 'Configure sua loja', desc: 'Nome, contato, regras de retirada e entrega.' },
    { title: 'Cadastre produtos ou serviços', desc: 'Preços, fotos, complementos e tempo de preparo.' },
    { title: 'Defina horários disponíveis', desc: 'Grade semanal, capacidade e exceções.' },
    { title: 'Cliente escolhe e agenda', desc: 'Fluxo guiado no cardápio digital — sem ambiguidade.' },
    { title: 'Pedido chega organizado pelo WhatsApp', desc: 'Você confirma e produz com tudo no lugar certo.' }
  ],
  sectionDemo: 'Demonstração',
  sectionDemoLead: 'Toque nos cards abaixo para abrir o ambiente de demonstração ou falar com a WSJ.',
  demoCardMenuTitle: 'Ver cardápio demo',
  demoCardMenuDesc: 'Experiência do cliente: cardápio, carrinho e agendamento.',
  demoCardMenuPricePrefix: 'A partir de ',
  demoCardAdminTitle: 'Acessar painel demo',
  demoCardAdminDesc: 'Visão do lojista: pedidos, agenda e catálogo.',
  demoCardWsjTitle: 'Falar com a WSJ',
  demoCardWsjDesc: 'Tire dúvidas, peça proposta ou implantação assistida.',
  sectionCta: 'Pronto para transformar seu atendimento?',
  sectionCtaLead:
    'Mostre profissionalismo, reduza erros e entregue uma experiência melhor para seus clientes.',
  whatsappMessage: 'Olá! Quero saber mais sobre o WSJ Pedidos.',
  sectionProblemsTitle: 'O que o WSJ Pedidos resolve',
  sectionProblemsLead: 'Problemas comuns em restaurantes e negócios locais — e uma resposta única.',
  problemCards: [
    {
      title: 'Perda de pedidos no WhatsApp',
      desc: 'Conversas longas, áudios e prints somem no meio do fluxo — e o pedido some junto.'
    },
    {
      title: 'Falta de organização',
      desc: 'Planilhas, papel e memória não escalam quando o movimento aumenta.'
    },
    {
      title: 'Delivery dependente de apps externos',
      desc: 'Comissões altas e pouco controle sobre a operação e a marca.'
    },
    {
      title: 'Cardápios desatualizados',
      desc: 'PDFs estáticos, fotos antigas e preços que não batem com o balcão.'
    },
    {
      title: 'Falta de automação',
      desc: 'Confirmar horário, somar total e repassar endereço tudo na mão.'
    },
    {
      title: 'Atendimento lento',
      desc: 'Cliente espera resposta enquanto a equipa apaga incêndios no balcão.'
    }
  ],
  problemsClosing: 'O WSJ Pedidos resolve tudo isso em uma única plataforma.',
  plansBadge: 'Planos',
  plansTitle: 'Planos alinhados à operação real — sem surpresas na infraestrutura',
  plansLead:
    'Preços e limites claros para o lojista. O período de teste ajuda a validar o fluxo; os planos pagos acompanham o crescimento com cotas que protegem custos de servidor, base de dados e tráfego.',
  plansSustainabilityLead:
    'Sem promessas de armazenamento ou catálogo ilimitados: cotas evitam uso abusivo e mantêm o serviço sustentável para todos.',
  plansBillingGroupLabel: 'Período de faturação (Pro e Premium)',
  plansMonthly: 'Mensal',
  plansYearly: 'Anual',
  plansSaveShort: 'Poupe ~17%',
  plansPerMonth: '/mês',
  plansAnnualAppliesTo: 'A opção anual aplica-se apenas aos planos Pro e Premium. O Starter é período de teste de 30 dias.',
  plansAnnualExplain: 'No anual, faturamos {n} meses pelo período de 12 — o equivalente a cerca de 2 meses em poupança.',
  plansAnnualBilled: '{amount} faturados uma vez por ano.',
  plansSavingsLine: 'Poupe cerca de {pct}% face a 12 mensalidades (≈ {amount}).',
  plansInfraNote:
    'Limites e cotas existem para manter a plataforma estável enquanto a infraestrutura evolui (VPS, base de dados, armazenamento de imagens e tráfego). Podem ser ajustados com comunicação prévia aos clientes.',
  plansLimitsEvolutionNote:
    'Novos limites ou upgrades de plano podem surgir à medida que o produto amadurece — sempre com foco em previsibilidade de custo para a WSJ e para o seu negócio.',
  planStarterName: 'Starter — Teste Gratuito',
  planStarterBadge: '30 dias',
  planStarterTagline: '30 dias grátis',
  planStarterPeriodLabel: 'durante 30 dias',
  planStarterDisclaimer:
    'Experimente a plataforma e descubra como funciona o fluxo completo de pedidos digitais.',
  planStarterIncludedHeading: 'Incluído no teste',
  planStarterIncluded: [
    'Cardápio digital online',
    'Painel administrativo',
    'Recebimento de pedidos',
    'Integração com WhatsApp',
    'Gestão de horários',
    'Link público da loja',
    'Tutoriais em vídeo para configuração'
  ],
  planStarterLimitsHeading: 'Limites do teste',
  planStarterLimits: [
    'Até 20 produtos',
    'Até 5 categorias',
    'Recursos limitados durante o período experimental',
    'Sem suporte personalizado',
    'Após 30 dias, escolha um plano pago para continuar'
  ],
  planStarterCtaDemo: 'Ver demonstração',
  planStarterCtaWhatsapp: 'Ativar teste grátis',
  planProName: 'Pro',
  planProTagline: 'Para negócios que preferem autonomia e gestão própria',
  planProDescription:
    'Ideal para restaurantes, lanchonetes, hamburguerias, pizzarias e pequenos negócios que querem profissionalizar pedidos online com liberdade e organização.',
  planProFeaturesHeading: 'Inclui',
  planProFeatures: [
    'Até 300 produtos',
    'Categorias organizadas',
    'Cardápio digital personalizado',
    'Link público da loja',
    'Painel administrativo completo',
    'Recebimento e organização de pedidos',
    'Integração com WhatsApp',
    'Gestão de horários',
    'Tutoriais completos em vídeo',
    'Atualizações constantes da plataforma',
    'Suporte por email'
  ],
  planProImportantHeading: 'O cliente é responsável pela gestão da loja',
  planProImportantItems: [
    'Cadastro de produtos',
    'Envio de fotos',
    'Descrições',
    'Organização do cardápio',
    'Atualizações do catálogo'
  ],
  planProIdealHeading: 'Ideal para',
  planProIdeal: [
    'Negócios que gostam de autonomia',
    'Empresas que querem reduzir custos',
    'Clientes que preferem aprender pela plataforma'
  ],
  planProFootnote: '',
  planPremiumName: 'Premium',
  planPremiumBadge: 'Maior volume',
  planPremiumTagline: 'Para empresas que querem suporte prioritário e acompanhamento próximo',
  planPremiumDescription:
    'Plano ideal para negócios com maior volume de pedidos ou para clientes que preferem apoio direto da equipe WSJ.',
  planPremiumFeaturesHeading: 'Inclui tudo do plano Pro +',
  planPremiumFeatures: [
    'Configuração assistida da loja',
    'Apoio na organização inicial do cardápio',
    'Suporte prioritário via WhatsApp',
    'Configuração de delivery próprio',
    'Prioridade operacional em atendimentos',
    'Apoio na atualização de produtos',
    'Apoio com imagens e descrições',
    'Atendimento personalizado',
    'Acompanhamento mais próximo da operação'
  ],
  planPremiumDifferentialHeading: 'Diferencial Premium',
  planPremiumDifferential:
    'Enquanto no plano Pro o cliente gerencia tudo sozinho através dos tutoriais, no Premium a equipe WSJ oferece acompanhamento mais próximo para acelerar a configuração e operação da loja.',
  planPremiumIdealHeading: 'Ideal para',
  planPremiumIdeal: [
    'Empresas com maior fluxo de pedidos',
    'Negócios que querem mais comodidade',
    'Clientes que preferem suporte humano',
    'Operações que precisam de prioridade'
  ],
  planPremiumFootnote:
    'O suporte prioritário funciona em horário comercial através dos canais oficiais da WSJ.',
  planCtaDemo: 'Ver demonstração',
  planCtaAdmin: 'Começar agora',
  planCtaWhatsapp: 'Falar no WhatsApp',
  planPremiumCtaActivation: 'Solicitar ativação',
  saasFlowTitle: 'Como funciona o WSJ Pedidos',
  saasFlowLead: 'Da estrutura inicial ao pedido no WhatsApp — passos objetivos.',
  saasFlowStepLabel: 'PASSO {n}',
  saasFlowSteps: [
    {
      title: 'Criamos sua estrutura inicial',
      desc: 'Loja, regras básicas de horário e o esqueleto do cardápio — para você não começar do zero.'
    },
    {
      title: 'Você adiciona produtos e categorias',
      desc: 'Cadastro guiado no painel: preços, fotos dentro da cota do plano e organização do catálogo.'
    },
    {
      title: 'Receba seu link da loja',
      desc: 'Endereço público para divulgar no WhatsApp, redes e QR Code — o cliente acessa direto o cardápio.'
    },
    {
      title: 'Clientes fazem pedidos organizados pelo WhatsApp',
      desc: 'O pedido chega estruturado para produção e confirmação — menos ruído, menos erro.'
    }
  ],
  sectionUnifiedTitle: 'Tudo em um único sistema',
  sectionUnifiedLead: 'Módulos que trabalham juntos — sem frankenstein de ferramentas soltas.',
  unifiedBlocks: [
    { title: 'Cardápio digital', desc: 'Apresentação premium no telemóvel, com complementos e regras claras.' },
    { title: 'WhatsApp', desc: 'Pedidos e resumos objetivos no canal que o cliente já usa.' },
    { title: 'Agenda inteligente', desc: 'Capacidade, duração e bloqueios automáticos no mesmo motor.' },
    { title: 'Painel administrativo', desc: 'Pedidos, catálogo e horários numa vista feita para o dia a dia.' },
    { title: 'Delivery', desc: 'Modalidades e fluxo alinhados à sua operação — sem depender só de terceiros.' },
    { title: 'Impressão de pedidos', desc: 'Cozinha e balcão recebem o pedido formatado, no ritmo certo.' },
    { title: 'Gestão de horários', desc: 'Grade semanal, exceções e proteção de slots ocupados.' },
    { title: 'Multi idioma', desc: 'Atenda turistas e clientes bilíngues sem fricção extra.' }
  ],
  finalCtaTitle: 'Transforme seu atendimento com o WSJ Pedidos',
  finalCtaSubtitle: 'Automatize pedidos, organize horários e venda mais no WhatsApp.',
  finalCtaScheduleDemo: 'Agendar demonstração',
  finalCtaWhatsapp: 'Falar no WhatsApp',
  trustNoContract: 'Sem fidelidade',
  trustFastSetup: 'Setup rápido',
  trustSupportRegions: 'Suporte Brasil e Portugal',
  heroMock: {
    orderLabel: 'Novo pedido',
    orderCustomer: 'Cliente · retirada 18h',
    orderBadge: 'Recebido',
    agendaLabel: 'Agenda · hoje',
    slotBusy: 'Ocupado',
    slotFree: 'Livre',
    productLabel: 'Bolo · sob encomenda',
    productMeta: 'Entrega sáb · observações salvas',
    priceFromPrefix: 'A partir de ',
    blockTitle: 'Horário protegido',
    blockSubtitle: 'Cliente não vê slot duplicado'
  }
};

const ptPT = {
  ...ptBR,
  heroTrust: 'Cardápio digital · Agenda inteligente · Painel do comerciante · WhatsApp integrado',
  sectionBusinessLead: 'O mesmo núcleo poderoso, com a imagem do seu atendimento.',
  controlFeatures: [
    { title: 'Cardápio digital', desc: 'Catálogo elegante no telemóvel, com fotos, preços e complementos.' },
    { title: 'Pedidos por WhatsApp', desc: 'Resumo claro do pedido ou marcação direta na conversa.' },
    { title: 'Painel do comerciante', desc: 'Pedidos, agenda e catálogo num painel pensado para o dia a dia.' },
    { title: 'Entrega e levantamento', desc: 'Modalidades claras para o cliente e simples de operar.' },
    { title: 'Produtos por encomenda', desc: 'Prazo, notas e estado para doces e salgados.' },
    { title: 'Serviços com hora marcada', desc: 'Reserva com duração e profissional certo.' },
    { title: 'Controlo de capacidade', desc: 'Limite por horário para não prometer o impossível.' },
    { title: 'Bloqueio de horários ocupados', desc: 'Evita choques de horários e mensagens em duplicado.' }
  ],
  afterItems: [
    'O cliente escolhe data e horário com clareza',
    'A agenda bloqueia horários ocupados automaticamente',
    'O comerciante gere tudo no painel',
    'O pedido chega organizado no WhatsApp',
    'Menos erros, mais profissionalismo e reputação'
  ],
  sectionAgendaLead: 'Regras de negócio que acompanham a rotina real — não uma folha estática.',
  agendaPoints: [
    { title: 'Horários por dia da semana', desc: 'Aberturas diferentes para segunda, sábado ou feriado.' },
    { title: 'Datas especiais', desc: 'Bloqueios ou janelas extra quando precisar.' },
    { title: 'Capacidade por horário', desc: 'Limite de pedidos ou atendimentos por faixa.' },
    { title: 'Serviços com duração', desc: 'O intervalo respeita automaticamente o tempo do serviço.' },
    { title: 'Bloqueio automático', desc: 'Horário ocupado deixa de aparecer — sem overbooking.' }
  ],
  sectionHowLead: 'Em poucos passos coloca a operação em piloto automático.',
  howSteps: [
    { title: 'Configure a sua loja', desc: 'Nome, contacto, regras de levantamento e entrega.' },
    { title: 'Registe produtos ou serviços', desc: 'Preços, fotos, complementos e tempo de preparação.' },
    { title: 'Defina horários disponíveis', desc: 'Grelha semanal, capacidade e exceções.' },
    { title: 'O cliente escolhe e agenda', desc: 'Fluxo guiado no cardápio digital — sem ambiguidade.' },
    { title: 'O pedido chega organizado no WhatsApp', desc: 'Confirma e produz com tudo no sítio certo.' }
  ],
  sectionDemoLead: 'Toque nos cartões abaixo para abrir a demonstração ou falar com a WSJ.',
  demoCardMenuDesc: 'Experiência do cliente: cardápio, carrinho e marcação.',
  demoCardMenuPricePrefix: 'Desde ',
  demoCardAdminDesc: 'Visão do comerciante: pedidos, agenda e catálogo.',
  whatsappMessage: 'Olá! Quero saber mais sobre o WSJ Pedidos.',
  sectionProblemsLead: 'Problemas comuns em restaurantes e negócios locais — e uma resposta única.',
  problemCards: [
    {
      title: 'Perda de pedidos no WhatsApp',
      desc: 'Conversas longas, áudios e capturas perdem-se no meio do fluxo — e o pedido perde-se também.'
    },
    {
      title: 'Falta de organização',
      desc: 'Folhas, papel e memória não acompanham quando o movimento aumenta.'
    },
    {
      title: 'Delivery dependente de apps externos',
      desc: 'Comissões elevadas e pouco controlo sobre a operação e a marca.'
    },
    {
      title: 'Cardápios desatualizados',
      desc: 'PDFs estáticos, fotos antigas e preços que não batem com o balcão.'
    },
    {
      title: 'Falta de automação',
      desc: 'Confirmar hora, somar total e repetir morada — tudo manual.'
    },
    {
      title: 'Atendimento lento',
      desc: 'O cliente espera resposta enquanto a equipa apaga incêndios no balcão.'
    }
  ],
  problemsClosing: 'O WSJ Pedidos resolve tudo isto numa única plataforma.',
  plansTitle: 'Planos alinhados à operação real — sem surpresas na infraestrutura',
  plansLead:
    'Preços e limites claros. O teste de 30 dias valida o fluxo; os planos pagos acompanham o crescimento com cotas que protegem custos de servidor, base de dados e tráfego.',
  plansSustainabilityLead:
    'Sem armazenamento ou catálogo ilimitados: cotas reduzem uso abusivo e mantêm o serviço sustentável.',
  plansBillingGroupLabel: 'Período de faturação (Pro e Premium)',
  plansAnnualAppliesTo: 'A opção anual aplica-se apenas aos planos Pro e Premium. O Starter é um teste de 30 dias.',
  plansInfraNote:
    'Limites e cotas mantêm a plataforma estável enquanto a infraestrutura evolui (VPS, base de dados, imagens e tráfego). Podem ser ajustados com aviso prévio aos clientes.',
  plansLimitsEvolutionNote:
    'Novos limites ou upgrades podem surgir com o produto — sempre com foco em custos previsíveis para a WSJ e para o seu negócio.',
  planStarterTagline: '30 dias grátis',
  planStarterPeriodLabel: 'durante 30 dias',
  planStarterDisclaimer:
    'Experimente a plataforma e descubra como funciona o fluxo completo de pedidos digitais.',
  planStarterIncluded: [
    'Cardápio digital online',
    'Painel administrativo',
    'Receção de pedidos',
    'Integração com WhatsApp',
    'Gestão de horários',
    'Link público da loja',
    'Tutoriais em vídeo para configuração'
  ],
  planStarterLimits: [
    'Até 20 produtos',
    'Até 5 categorias',
    'Recursos limitados durante o período experimental',
    'Sem suporte personalizado',
    'Após 30 dias, escolha um plano pago para continuar'
  ],
  planStarterCtaDemo: 'Ver demonstração',
  planStarterCtaWhatsapp: 'Ativar teste grátis',
  planProTagline: 'Para negócios que preferem autonomia e gestão própria',
  planProDescription:
    'Ideal para restaurantes, lanchonetes, hamburguerias, pizzarias e pequenos negócios que querem profissionalizar pedidos online com liberdade e organização.',
  planProFeaturesHeading: 'Inclui',
  planProFeatures: [
    'Até 300 produtos',
    'Categorias organizadas',
    'Cardápio digital personalizado',
    'Link público da loja',
    'Painel administrativo completo',
    'Receção e organização de pedidos',
    'Integração com WhatsApp',
    'Gestão de horários',
    'Tutoriais completos em vídeo',
    'Atualizações constantes da plataforma',
    'Suporte por email'
  ],
  planProImportantHeading: 'O cliente é responsável pela gestão da loja',
  planProImportantItems: [
    'Registo de produtos',
    'Envio de fotos',
    'Descrições',
    'Organização do cardápio',
    'Atualizações do catálogo'
  ],
  planProIdealHeading: 'Ideal para',
  planProIdeal: [
    'Negócios que gostam de autonomia',
    'Empresas que querem reduzir custos',
    'Clientes que preferem aprender pela plataforma'
  ],
  planProFootnote: '',
  planPremiumTagline: 'Para empresas que querem suporte prioritário e acompanhamento próximo',
  planPremiumDescription:
    'Plano ideal para negócios com maior volume de pedidos ou para clientes que preferem apoio direto da equipa WSJ.',
  planPremiumFeaturesHeading: 'Inclui tudo do plano Pro +',
  planPremiumFeatures: [
    'Configuração assistida da loja',
    'Apoio na organização inicial do cardápio',
    'Suporte prioritário via WhatsApp',
    'Configuração de delivery próprio',
    'Prioridade operacional em atendimentos',
    'Apoio na atualização de produtos',
    'Apoio com imagens e descrições',
    'Atendimento personalizado',
    'Acompanhamento mais próximo da operação'
  ],
  planPremiumDifferentialHeading: 'Diferencial Premium',
  planPremiumDifferential:
    'Enquanto no plano Pro o cliente gere tudo sozinho através dos tutoriais, no Premium a equipa WSJ oferece acompanhamento mais próximo para acelerar a configuração e operação da loja.',
  planPremiumIdealHeading: 'Ideal para',
  planPremiumIdeal: [
    'Empresas com maior fluxo de pedidos',
    'Negócios que querem mais comodidade',
    'Clientes que preferem suporte humano',
    'Operações que precisam de prioridade'
  ],
  planPremiumFootnote:
    'O suporte prioritário funciona em horário comercial através dos canais oficiais da WSJ.',
  planCtaAdmin: 'Começar agora',
  planCtaWhatsapp: 'Falar no WhatsApp',
  planPremiumCtaActivation: 'Solicitar ativação',
  saasFlowLead: 'Da estrutura inicial ao pedido no WhatsApp — passos objetivos.',
  saasFlowSteps: [
    {
      title: 'Criamos a sua estrutura inicial',
      desc: 'Loja, regras básicas de horário e o esqueleto do cardápio — para não começar do zero.'
    },
    {
      title: 'Adicione produtos e categorias',
      desc: 'Registo no painel: preços, fotos dentro da cota do plano e organização do catálogo.'
    },
    {
      title: 'Receba o link da sua loja',
      desc: 'Endereço público para partilhar no WhatsApp, redes e QR Code — o cliente acede diretamente ao cardápio.'
    },
    {
      title: 'Os clientes fazem pedidos organizados pelo WhatsApp',
      desc: 'O pedido chega estruturado para produção e confirmação — menos ruído, menos erro.'
    }
  ],
  sectionUnifiedLead: 'Módulos que trabalham em conjunto — sem frankenstein de ferramentas soltas.',
  unifiedBlocks: [
    { title: 'Cardápio digital', desc: 'Apresentação premium no telemóvel, com complementos e regras claras.' },
    { title: 'WhatsApp', desc: 'Pedidos e resumos objetivos no canal que o cliente já usa.' },
    { title: 'Agenda inteligente', desc: 'Capacidade, duração e bloqueios automáticos no mesmo motor.' },
    { title: 'Painel administrativo', desc: 'Pedidos, catálogo e horários numa vista feita para o dia a dia.' },
    { title: 'Delivery', desc: 'Modalidades e fluxo alinhados à sua operação — sem depender só de terceiros.' },
    { title: 'Impressão de pedidos', desc: 'Cozinha e balcão recebem o pedido formatado, ao ritmo certo.' },
    { title: 'Gestão de horários', desc: 'Grelha semanal, exceções e proteção de intervalos ocupados.' },
    { title: 'Multi idioma', desc: 'Atenda turistas e clientes bilíngues sem fricção extra.' }
  ],
  finalCtaSubtitle: 'Automatize pedidos, organize horários e venda mais no WhatsApp.',
  finalCtaScheduleDemo: 'Agendar demonstração',
  trustFastSetup: 'Configuração rápida',
  heroMock: {
    ...ptBR.heroMock,
    orderCustomer: 'Cliente · levantamento 18h',
    productMeta: 'Entrega sáb · notas guardadas',
    priceFromPrefix: 'Desde '
  }
};

const enUS = {
  metaTitle: 'WSJ Pedidos | WSJ Digital Solutions',
  badge: 'WSJ product',
  heroTitle: 'Sell, schedule and manage orders in one platform',
  heroSubtitle:
    'A complete system for local businesses that need to take orders, control time slots, sell via WhatsApp and serve customers better.',
  heroTrust: 'Digital menu · Smart schedule · Merchant dashboard · WhatsApp flow',
  btnDemo: 'View demo',
  btnAdmin: 'Open dashboard',
  btnWhatsapp: 'WhatsApp us',
  btnWant: 'I want WSJ Pedidos',
  btnDemoMenu: 'Open demo menu',
  btnDemoAdmin: 'Open demo admin',
  btnTalkWsj: 'Talk to WSJ',
  midCtaTitle: 'Less messy chat. More confirmed orders.',
  midCtaSubtitle: 'A professional flow from menu to WhatsApp — customers know what to pick and when.',
  sectionBusiness: 'Built for your business type',
  sectionBusinessLead: 'The same powerful core, tailored to how you serve.',
  businessTypes: [
    { title: 'Barbershops', desc: 'Timed services, queues and packages under control.' },
    { title: 'Beauty salons', desc: 'Per-stylist scheduling with clear slot rules.' },
    { title: 'Nails & manicure', desc: 'Short slots, service list and upsell on the menu.' },
    { title: 'Aesthetics', desc: 'Treatments with duration and automatic calendar recovery.' },
    { title: 'Bakeries & cakes', desc: 'Orders with date, flavour and notes without mistakes.' },
    { title: 'Savouries to order', desc: 'Batch production with pickup and daily capacity.' },
    { title: 'Restaurants & delivery', desc: 'Organised orders for delivery or counter.' },
    { title: 'Personal trainer / hourly', desc: 'Capacity per slot and blocking of what is already sold.' }
  ],
  sectionControl: 'Full control of orders',
  sectionControlLead: 'Everything customers see and everything you manage — connected in real time.',
  controlFeatures: [
    { title: 'Digital menu', desc: 'A polished mobile catalogue with photos, prices and add-ons.' },
    { title: 'Orders via WhatsApp', desc: 'Clear summaries of orders or bookings in the chat.' },
    { title: 'Merchant dashboard', desc: 'Orders, schedule and catalogue in one daily-driver UI.' },
    { title: 'Delivery & pickup', desc: 'Clear modes for customers and easy operations for you.' },
    { title: 'Made-to-order products', desc: 'Lead time, notes and status for sweets and savouries.' },
    { title: 'Booked services', desc: 'Reservations with duration and the right professional.' },
    { title: 'Capacity control', desc: 'Per-slot limits so you do not over-promise.' },
    { title: 'Busy slots blocked', desc: 'No double bookings or duplicate messages.' }
  ],
  sectionCompare: 'From chaos to control',
  sectionCompareLead: 'WhatsApp stays at the centre — with a professional process around it.',
  beforeTitle: 'Before',
  afterTitle: 'After, with WSJ Pedidos',
  beforeItems: [
    'Orders lost in endless WhatsApp threads',
    'Duplicate or forgotten time slots',
    'Customers constantly asking availability',
    'No standard way to collect details',
    'Mistakes on flavours and custom orders'
  ],
  afterItems: [
    'Customers pick date and time with clarity',
    'Calendar blocks busy slots automatically',
    'You manage everything in the dashboard',
    'Orders arrive organised in WhatsApp',
    'Fewer errors, more professionalism and trust'
  ],
  sectionAgenda: 'Smart scheduling',
  sectionAgendaLead: 'Business rules that match real operations — not a static spreadsheet.',
  agendaPoints: [
    { title: 'Weekly hours', desc: 'Different openings for weekdays, Saturday or holidays.' },
    { title: 'Special dates', desc: 'Blockouts or extra windows when you need them.' },
    { title: 'Capacity per slot', desc: 'Limit orders or appointments per window.' },
    { title: 'Services with duration', desc: 'Slots respect service length automatically.' },
    { title: 'Automatic blocking', desc: 'Busy times disappear for customers — no overbooking.' }
  ],
  sectionHow: 'How it works',
  sectionHowLead: 'A few steps to put day-to-day operations on autopilot.',
  howSteps: [
    { title: 'Set up your store', desc: 'Name, contact, pickup and delivery rules.' },
    { title: 'Add products or services', desc: 'Prices, photos, add-ons and prep time.' },
    { title: 'Define available hours', desc: 'Weekly grid, capacity and exceptions.' },
    { title: 'Customers choose and book', desc: 'Guided flow on the digital menu — no ambiguity.' },
    { title: 'Orders arrive organised in WhatsApp', desc: 'You confirm and fulfil with everything in place.' }
  ],
  sectionDemo: 'Live demo',
  sectionDemoLead: 'Use the cards below to open the demo environment or talk to WSJ.',
  demoCardMenuTitle: 'Open demo menu',
  demoCardMenuDesc: 'Customer experience: menu, cart and booking.',
  demoCardMenuPricePrefix: 'From ',
  demoCardAdminTitle: 'Open demo admin',
  demoCardAdminDesc: 'Merchant view: orders, schedule and catalogue.',
  demoCardWsjTitle: 'Talk to WSJ',
  demoCardWsjDesc: 'Questions, proposal or assisted onboarding.',
  sectionCta: 'Ready to transform your service?',
  sectionCtaLead: 'Look professional, reduce mistakes and deliver a better customer experience.',
  whatsappMessage: 'Hello! I would like to know more about WSJ Pedidos.',
  sectionProblemsTitle: 'What WSJ Pedidos solves',
  sectionProblemsLead: 'Typical pain points for restaurants and local businesses — one clear answer.',
  problemCards: [
    {
      title: 'Orders lost in WhatsApp',
      desc: 'Long threads, voice notes and screenshots get buried — and the order disappears too.'
    },
    {
      title: 'Lack of organisation',
      desc: 'Spreadsheets, paper and memory do not scale when volume grows.'
    },
    {
      title: 'Delivery tied to third‑party apps',
      desc: 'High fees and little control over operations and brand.'
    },
    {
      title: 'Outdated menus',
      desc: 'Static PDFs, old photos and prices that do not match the counter.'
    },
    {
      title: 'No automation',
      desc: 'Confirming times, totals and addresses stays fully manual.'
    },
    {
      title: 'Slow responses',
      desc: 'Customers wait while the team fights fires at the counter.'
    }
  ],
  problemsClosing: 'WSJ Pedidos solves all of this in one platform.',
  plansBadge: 'Plans',
  plansTitle: 'Pricing aligned with real operations — no hidden infrastructure risk',
  plansLead:
    'Clear limits and pricing. The 30-day trial validates the flow; paid tiers scale with quotas that protect hosting, database and traffic costs.',
  plansSustainabilityLead:
    'No “unlimited” storage or catalogues: quotas reduce abuse and keep the service sustainable for everyone.',
  plansBillingGroupLabel: 'Billing period (Pro & Premium)',
  plansMonthly: 'Monthly',
  plansYearly: 'Yearly',
  plansSaveShort: 'Save ~17%',
  plansPerMonth: '/mo',
  plansAnnualAppliesTo: 'Annual billing applies to Pro and Premium only. Starter is a 30-day trial.',
  plansAnnualExplain: 'On yearly billing we charge for {n} months across 12 — about two months saved.',
  plansAnnualBilled: '{amount} billed once per year.',
  plansSavingsLine: 'Save about {pct}% vs twelve monthly payments (≈ {amount}).',
  plansInfraNote:
    'Limits and quotas keep the platform stable as infrastructure grows (VPS, database, images and bandwidth). They may change with advance notice to customers.',
  plansLimitsEvolutionNote:
    'Future limit tweaks or plan upgrades may appear as the product matures — always with predictable cost for WSJ and for your business.',
  planStarterName: 'Starter — Free Trial',
  planStarterBadge: '30 days',
  planStarterTagline: '30 days free',
  planStarterPeriodLabel: 'for 30 days',
  planStarterDisclaimer:
    'Try the platform and discover how the full digital ordering flow works.',
  planStarterIncludedHeading: 'Included in the trial',
  planStarterIncluded: [
    'Online digital menu',
    'Admin dashboard',
    'Order intake',
    'WhatsApp integration',
    'Opening hours management',
    'Public store link',
    'Video tutorials for setup'
  ],
  planStarterLimitsHeading: 'Trial limits',
  planStarterLimits: [
    'Up to 20 products',
    'Up to 5 categories',
    'Limited features during the trial period',
    'No personalised support',
    'After 30 days, choose a paid plan to continue'
  ],
  planStarterCtaDemo: 'View demo',
  planStarterCtaWhatsapp: 'Start free trial',
  planProName: 'Pro',
  planProTagline: 'For businesses that prefer autonomy and self-management',
  planProDescription:
    'Ideal for restaurants, snack bars, burger shops, pizzerias and small businesses that want to professionalise online ordering with freedom and organisation.',
  planProFeaturesHeading: 'Includes',
  planProFeatures: [
    'Up to 300 products',
    'Organised categories',
    'Personalised digital menu',
    'Public store link',
    'Full admin dashboard',
    'Order intake and organisation',
    'WhatsApp integration',
    'Opening hours management',
    'Complete video tutorials',
    'Ongoing platform updates',
    'Email support'
  ],
  planProImportantHeading: 'The customer is responsible for store management',
  planProImportantItems: [
    'Product registration',
    'Photo uploads',
    'Descriptions',
    'Menu organisation',
    'Catalogue updates'
  ],
  planProIdealHeading: 'Ideal for',
  planProIdeal: [
    'Businesses that value autonomy',
    'Companies looking to reduce costs',
    'Customers who prefer learning through the platform'
  ],
  planProFootnote: '',
  planPremiumName: 'Premium',
  planPremiumBadge: 'Higher volume',
  planPremiumTagline: 'For companies that want priority support and closer guidance',
  planPremiumDescription:
    'The ideal plan for businesses with higher order volume or customers who prefer direct support from the WSJ team.',
  planPremiumFeaturesHeading: 'Everything in Pro +',
  planPremiumFeatures: [
    'Assisted store setup',
    'Help with initial menu organisation',
    'Priority support via WhatsApp',
    'Own delivery setup',
    'Operational priority in support',
    'Help updating products',
    'Help with images and descriptions',
    'Personalised service',
    'Closer operational follow-up'
  ],
  planPremiumDifferentialHeading: 'Premium advantage',
  planPremiumDifferential:
    'While on Pro the customer manages everything alone through tutorials, on Premium the WSJ team offers closer guidance to speed up store setup and daily operations.',
  planPremiumIdealHeading: 'Ideal for',
  planPremiumIdeal: [
    'Businesses with higher order flow',
    'Operations that want more convenience',
    'Customers who prefer human support',
    'Operations that need priority handling'
  ],
  planPremiumFootnote:
    'Priority support is available during business hours through WSJ’s official channels.',
  planCtaDemo: 'View demo',
  planCtaAdmin: 'Get started',
  planCtaWhatsapp: 'Talk on WhatsApp',
  planPremiumCtaActivation: 'Request activation',
  saasFlowTitle: 'How WSJ Pedidos works',
  saasFlowLead: 'From initial setup to orders on WhatsApp — clear steps.',
  saasFlowStepLabel: 'STEP {n}',
  saasFlowSteps: [
    {
      title: 'We set up your initial structure',
      desc: 'Store, basic hour rules and a menu skeleton — so you are not starting from a blank page.'
    },
    {
      title: 'You add products and categories',
      desc: 'Guided entries in the dashboard: prices, photos within your plan quota and a tidy catalogue.'
    },
    {
      title: 'You receive your store link',
      desc: 'A public URL to share on WhatsApp, social and QR codes — customers open the menu directly.'
    },
    {
      title: 'Customers place orders, organised into WhatsApp',
      desc: 'Orders arrive structured for production and confirmation — less noise, fewer mistakes.'
    }
  ],
  sectionUnifiedTitle: 'Everything in one system',
  sectionUnifiedLead: 'Modules that work together — not a patchwork of disconnected tools.',
  unifiedBlocks: [
    { title: 'Digital menu', desc: 'Premium presentation on mobile, with add-ons and clear rules.' },
    { title: 'WhatsApp', desc: 'Orders and crisp summaries on the channel customers already use.' },
    { title: 'Smart schedule', desc: 'Capacity, duration and automatic busy blocking in one engine.' },
    { title: 'Admin dashboard', desc: 'Orders, catalogue and hours in a view built for daily work.' },
    { title: 'Delivery', desc: 'Modes and flow aligned to your operation — beyond apps alone.' },
    { title: 'Order printing', desc: 'Kitchen and counter get a formatted ticket at the right time.' },
    { title: 'Hours management', desc: 'Weekly grid, exceptions and protection for busy slots.' },
    { title: 'Multi-language', desc: 'Serve tourists and bilingual customers without extra friction.' }
  ],
  finalCtaTitle: 'Transform your service with WSJ Pedidos',
  finalCtaSubtitle: 'Automate orders, organise hours and sell more on WhatsApp.',
  finalCtaScheduleDemo: 'Book a demo',
  finalCtaWhatsapp: 'WhatsApp us',
  trustNoContract: 'No lock-in',
  trustFastSetup: 'Fast setup',
  trustSupportRegions: 'Support in Brazil & Portugal',
  heroMock: {
    orderLabel: 'New order',
    orderCustomer: 'Customer · pickup 6pm',
    orderBadge: 'Received',
    agendaLabel: 'Schedule · today',
    slotBusy: 'Busy',
    slotFree: 'Free',
    productLabel: 'Cake · custom order',
    productMeta: 'Sat delivery · notes saved',
    priceFromPrefix: 'From ',
    blockTitle: 'Protected slot',
    blockSubtitle: 'Customers never see a duplicate slot'
  }
};

const fallbackLocales = ['es', 'fr', 'it', 'hi', 'de', 'nl', 'ru', 'ar', 'zh-CN', 'zh-TW'];

export const wsjPedidosPageByLang = {
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  en: enUS,
  ...Object.fromEntries(fallbackLocales.map((code) => [code, enUS]))
};
